module.exports = __webpack_public_path__ + "img/step_10.9b0cd8e1.svg";